// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/agent/v1/agent.proto (package mono.agent.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { ChatRequest, ChatResponse, DecideDocumentProposalRequest, DecideDocumentProposalResponse, DecideTeamMemoryRequest, DecideTeamMemoryResponse, DeleteConversationRequest, DeleteConversationResponse, DeleteFileRequest, DeleteFileResponse, DeleteMemoryRequest, DeleteMemoryResponse, GenerateRfiDraftRequest, GenerateRfiDraftResponse, GetChatModelSettingsRequest, GetChatModelSettingsResponse, GetConversationRequest, GetConversationResponse, GetFileChunksRequest, GetFileChunksResponse, GetFileRequest, GetFileResponse, GetProjectContextRequest, GetProjectContextResponse, GetSystemPromptRequest, GetSystemPromptResponse, GetTokenUsageSummaryRequest, GetTokenUsageSummaryResponse, ListConversationsRequest, ListConversationsResponse, ListFilesRequest, ListFilesResponse, ListHistoryRequest, ListHistoryResponse, ListMemoriesRequest, ListMemoriesResponse, ListModelsRequest, ListModelsResponse, ListUserTokenUsageRequest, ListUserTokenUsageResponse, StopChatSubmissionRequest, StopChatSubmissionResponse, TranscribeAudioRequest, TranscribeAudioResponse, UpdateChatModelSettingsRequest, UpdateChatModelSettingsResponse, UpdateConversationRequest, UpdateConversationResponse, UploadFileRequest, UploadFileResponse, UpsertMemoryRequest, UpsertMemoryResponse } from "./agent_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * AgentService provides AI agent chat and file operations.
 *
 * @generated from service mono.agent.v1.AgentService
 */ export const AgentService = {
    typeName: "mono.agent.v1.AgentService",
    methods: {
        /**
     * Chat sends a message and streams back agent responses (server-streaming).
     *
     * @generated from rpc mono.agent.v1.AgentService.Chat
     */ chat: {
            name: "Chat",
            I: ChatRequest,
            O: ChatResponse,
            kind: MethodKind.ServerStreaming
        },
        /**
     * ListModels returns available LLM models.
     *
     * @generated from rpc mono.agent.v1.AgentService.ListModels
     */ listModels: {
            name: "ListModels",
            I: ListModelsRequest,
            O: ListModelsResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListConversations returns conversations for a user.
     *
     * @generated from rpc mono.agent.v1.AgentService.ListConversations
     */ listConversations: {
            name: "ListConversations",
            I: ListConversationsRequest,
            O: ListConversationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetConversation returns a specific conversation with messages.
     *
     * @generated from rpc mono.agent.v1.AgentService.GetConversation
     */ getConversation: {
            name: "GetConversation",
            I: GetConversationRequest,
            O: GetConversationResponse,
            kind: MethodKind.Unary
        },
        /**
     * Explicit cancellation; browser disconnection does not stop generation.
     *
     * @generated from rpc mono.agent.v1.AgentService.StopChatSubmission
     */ stopChatSubmission: {
            name: "StopChatSubmission",
            I: StopChatSubmissionRequest,
            O: StopChatSubmissionResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateConversation updates conversation metadata (e.g. title).
     *
     * @generated from rpc mono.agent.v1.AgentService.UpdateConversation
     */ updateConversation: {
            name: "UpdateConversation",
            I: UpdateConversationRequest,
            O: UpdateConversationResponse,
            kind: MethodKind.Unary
        },
        /**
     * DeleteConversation removes a conversation.
     *
     * @generated from rpc mono.agent.v1.AgentService.DeleteConversation
     */ deleteConversation: {
            name: "DeleteConversation",
            I: DeleteConversationRequest,
            O: DeleteConversationResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListHistory returns conversation history for a user.
     *
     * @generated from rpc mono.agent.v1.AgentService.ListHistory
     */ listHistory: {
            name: "ListHistory",
            I: ListHistoryRequest,
            O: ListHistoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * UploadFile uploads a document for agent context.
     *
     * @generated from rpc mono.agent.v1.AgentService.UploadFile
     */ uploadFile: {
            name: "UploadFile",
            I: UploadFileRequest,
            O: UploadFileResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListFiles returns uploaded files.
     *
     * @generated from rpc mono.agent.v1.AgentService.ListFiles
     */ listFiles: {
            name: "ListFiles",
            I: ListFilesRequest,
            O: ListFilesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetFile returns a specific uploaded file.
     *
     * @generated from rpc mono.agent.v1.AgentService.GetFile
     */ getFile: {
            name: "GetFile",
            I: GetFileRequest,
            O: GetFileResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetFileChunks returns processed chunks for a file.
     *
     * @generated from rpc mono.agent.v1.AgentService.GetFileChunks
     */ getFileChunks: {
            name: "GetFileChunks",
            I: GetFileChunksRequest,
            O: GetFileChunksResponse,
            kind: MethodKind.Unary
        },
        /**
     * DeleteFile removes an uploaded file.
     *
     * @generated from rpc mono.agent.v1.AgentService.DeleteFile
     */ deleteFile: {
            name: "DeleteFile",
            I: DeleteFileRequest,
            O: DeleteFileResponse,
            kind: MethodKind.Unary
        },
        /**
     * TranscribeAudio turns a dictated chat message into text for the composer.
     * It returns text only and sends nothing: the user reviews the words before
     * they become a turn, since a mis-heard word is cheap to fix in the box and
     * expensive once the model has acted on it.
     *
     * @generated from rpc mono.agent.v1.AgentService.TranscribeAudio
     */ transcribeAudio: {
            name: "TranscribeAudio",
            I: TranscribeAudioRequest,
            O: TranscribeAudioResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetProjectContext returns context for a project.
     *
     * @generated from rpc mono.agent.v1.AgentService.GetProjectContext
     */ getProjectContext: {
            name: "GetProjectContext",
            I: GetProjectContextRequest,
            O: GetProjectContextResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetSystemPrompt returns the system prompt for a project.
     *
     * @generated from rpc mono.agent.v1.AgentService.GetSystemPrompt
     */ getSystemPrompt: {
            name: "GetSystemPrompt",
            I: GetSystemPromptRequest,
            O: GetSystemPromptResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetChatModelSettings returns the stored global model settings, the
     * effective (post-fallback) model ids, and the catalog of models whose
     * provider has an API key loaded.
     *
     * @generated from rpc mono.agent.v1.AgentService.GetChatModelSettings
     */ getChatModelSettings: {
            name: "GetChatModelSettings",
            I: GetChatModelSettingsRequest,
            O: GetChatModelSettingsResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateChatModelSettings switches the globally-active chat/subagent
     * models. Takes effect on new chat turns within the resolver TTL (~15s),
     * no redeploy.
     *
     * @generated from rpc mono.agent.v1.AgentService.UpdateChatModelSettings
     */ updateChatModelSettings: {
            name: "UpdateChatModelSettings",
            I: UpdateChatModelSettingsRequest,
            O: UpdateChatModelSettingsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetTokenUsageSummary returns global token consumption for a time range:
     * totals, per-day series, and by-model / by-source breakdowns.
     *
     * @generated from rpc mono.agent.v1.AgentService.GetTokenUsageSummary
     */ getTokenUsageSummary: {
            name: "GetTokenUsageSummary",
            I: GetTokenUsageSummaryRequest,
            O: GetTokenUsageSummaryResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListUserTokenUsage returns per-user token consumption for a time range,
     * ordered by total tokens descending, paginated.
     *
     * @generated from rpc mono.agent.v1.AgentService.ListUserTokenUsage
     */ listUserTokenUsage: {
            name: "ListUserTokenUsage",
            I: ListUserTokenUsageRequest,
            O: ListUserTokenUsageResponse,
            kind: MethodKind.Unary
        },
        /**
     * -------- Memory (personal + project notes) --------
     * Browser-facing proxies of pangaea's agentops memory RPCs. Tenant and
     * user come from the sabaody-injected gateway principal — never from
     * the request body.
     *
     * @generated from rpc mono.agent.v1.AgentService.ListMemories
     */ listMemories: {
            name: "ListMemories",
            I: ListMemoriesRequest,
            O: ListMemoriesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.agent.v1.AgentService.UpsertMemory
     */ upsertMemory: {
            name: "UpsertMemory",
            I: UpsertMemoryRequest,
            O: UpsertMemoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.agent.v1.AgentService.DeleteMemory
     */ deleteMemory: {
            name: "DeleteMemory",
            I: DeleteMemoryRequest,
            O: DeleteMemoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * Approve or reject a pending team note. Admins only.
     *
     * @generated from rpc mono.agent.v1.AgentService.DecideTeamMemory
     */ decideTeamMemory: {
            name: "DecideTeamMemory",
            I: DecideTeamMemoryRequest,
            O: DecideTeamMemoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * Decide an existing saved proposal. Operations come from saved history,
     * never from a browser-supplied edit payload.
     *
     * @generated from rpc mono.agent.v1.AgentService.DecideDocumentProposal
     */ decideDocumentProposal: {
            name: "DecideDocumentProposal",
            I: DecideDocumentProposalRequest,
            O: DecideDocumentProposalResponse,
            kind: MethodKind.Unary
        },
        /**
     * Generates a saved PENDING full-section replacement. Never writes an answer.
     * Decisions remain disabled until the RFI saved-proposal router is available.
     *
     * @generated from rpc mono.agent.v1.AgentService.GenerateRfiDraft
     */ generateRfiDraft: {
            name: "GenerateRfiDraft",
            I: GenerateRfiDraftRequest,
            O: GenerateRfiDraftResponse,
            kind: MethodKind.Unary
        }
    }
};
